import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Title' })({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        flexWrap: 'wrap',
        justifyContent: 'space-between'
    },
    avatar: {
        width: 32,
        height: 32,
        cursor: 'pointer'
    },
    source: {
        color: '#8E8E8E',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
    },
    id: {
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px'
    },
    text: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        whiteSpace: 'nowrap'
    }
});
